var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_3227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 0.399902C4.69693 0.399902 0.398926 4.6979 0.398926 9.9999C0.398794 11.2608 0.647042 12.5093 1.12949 13.6742C1.61194 14.8391 2.31914 15.8976 3.2107 16.7891C4.10226 17.6807 5.16072 18.3879 6.32563 18.8703C7.49053 19.3528 8.73907 19.601 9.99993 19.6009C15.3009 19.6009 19.5999 15.3029 19.5999 9.9999C19.5999 4.6979 15.3009 0.399902 9.99993 0.399902ZM10.8959 3.8659C11.8319 3.8659 12.1069 4.4089 12.1069 5.0299C12.1069 5.8049 11.4869 6.5219 10.4279 6.5219C9.54193 6.5219 9.11993 6.0769 9.14593 5.3399C9.14593 4.7189 9.66493 3.8659 10.8959 3.8659ZM8.49793 15.7499C7.85793 15.7499 7.39093 15.3609 7.83793 13.6559L8.57093 10.6309C8.69793 10.1469 8.71893 9.9529 8.57093 9.9529C8.37993 9.9529 7.54893 10.2869 7.05893 10.6169L6.73993 10.0939C8.29493 8.7949 10.0829 8.0329 10.8479 8.0329C11.4879 8.0329 11.5939 8.7889 11.2749 9.9529L10.4349 13.1329C10.2859 13.6949 10.3499 13.8889 10.4989 13.8889C10.6909 13.8889 11.3189 13.6569 11.9369 13.1699L12.2989 13.6559C10.7859 15.1679 9.13693 15.7499 8.49793 15.7499Z",
    fill: "#27C0D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_3227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNew);
export default __webpack_public_path__ + "static/media/InfoNew.5185640425885b1cd1cb2955759b333a.svg";
export { ForwardRef as ReactComponent };